import React, { createContext, useContext } from 'react'
import { useBasketTotals } from './useBasketTotals'

interface BasketTotalsContextValue {
  basketTotals: ReturnType<typeof useBasketTotals>
}

const BasketTotalsContext = createContext<BasketTotalsContextValue | null>(null)

export const useBasketTotalsContext = (): BasketTotalsContextValue => {
  const context = useContext(BasketTotalsContext)
  if (!context) {
    throw new Error(
      'useBasketTotalsContext must be used within a BasketTotalsProvider'
    )
  }
  return context
}

// Optional version that returns null if not in provider context
export const useBasketTotalsContextOptional =
  (): BasketTotalsContextValue | null => {
    return useContext(BasketTotalsContext)
  }

interface BasketTotalsProviderProps {
  children: React.ReactNode
}

export const BasketTotalsProvider: React.FC<BasketTotalsProviderProps> = ({
  children,
}) => {
  const basketTotals = useBasketTotals()

  return (
    <BasketTotalsContext.Provider value={{ basketTotals }}>
      {children}
    </BasketTotalsContext.Provider>
  )
}
